import { useCreateCustomEventFieldQuery } from 'api/MappingsAPI';
import { useCustomEventsQueryContext } from 'modules/customEvents/contexts';
import { useCustomEventDetailsContext } from 'modules/dataDictionary/contexts';
import { useCreateFieldModal } from 'modules/dataDictionary/hooks';
import { MappingFieldValues } from 'modules/dataDictionary/types';
import { createFieldPayload } from 'modules/dataDictionary/utils';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { CreateFieldModal } from './CreateFieldModal';

export const CreateCustomEventFieldModal = ({ parentName = '' }: { parentName?: string }) => {
  const { setError } = useFormContext();
  const { refetchCustomEventDetails: refetch, customEventDetails } = useCustomEventDetailsContext();
  const { project } = useCustomEventsQueryContext();
  const { customEventName } = useParams<{ customEventName: string }>();
  const { handleSubmit, hasError, isDisabled, isSubmitting, onClose, onError, onSuccess } =
    useCreateFieldModal({ refetch });

  const { mutate } = useCreateCustomEventFieldQuery(customEventName, { onSuccess, onError });

  const onSubmit = (data: MappingFieldValues) => {
    const payload = createFieldPayload(data, project?.id, parentName);
    const existingField = customEventDetails.find(
      (field) => field.fieldName === payload?.fieldName,
    );

    if (existingField) {
      setError('fieldName', { message: 'Duplicate name' });
      return null;
    }

    if (payload && !existingField) {
      mutate(payload);
    }
  };

  const nestedParentName = parentName.replace(`${customEventName}.`, '');

  return (
    <CreateFieldModal
      handleSubmit={handleSubmit(onSubmit)}
      hasError={hasError}
      isDisabled={isDisabled}
      isSubmitting={isSubmitting}
      onClose={onClose}
      parentName={nestedParentName}
    />
  );
};
